(() => {
  const cfg = window.themeConfig || {};
  if (!cfg.predictiveSearch) return;
  const input = document.querySelector('[data-predictive-search-input]');
  const output = document.querySelector('[data-predictive-search-results]');
  if (!input || !output) return;
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cfg.currency || 'GBP' }).format((Number(cents) || 0) / 100);
  let timer;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const term = input.value.trim();
    if (term.length < 2) { output.innerHTML = ''; return; }
    timer = setTimeout(async () => {
      try {
        const base = cfg.searchSuggestUrl || '/search/suggest';
        const limit = Number(cfg.predictiveSearchLimit) || 6;
        const response = await fetch(`${base}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=${limit}`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search failed');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        output.innerHTML = products.map((product) => `<a class="predictive-item" href="${escapeHTML(product.url)}">${product.featured_image?.url ? `<img src="${escapeHTML(product.featured_image.url)}&width=144" alt="" width="72" height="72" loading="lazy" decoding="async">` : ''}<div><h3>${escapeHTML(product.title)}</h3><p>${money(product.price)}</p></div></a>`).join('') || '<p class="muted">No matching products.</p>';
      } catch (error) { output.innerHTML = ''; }
    }, 280);
  });
})();
